import React from "react";
import "./Collabs.css";
import images from "../../../Utils/Images";
import posthog from "posthog-js";

const Collabs = () => {
  const showCollabs = posthog.isFeatureEnabled("collabs_section");

  if (!showCollabs) return null;

  const logos = [
    images.i1, images.i2, images.i3, images.i4, images.i5,
    images.i6, images.i7, images.i8, images.i9, images.i10,
  ];

  return (
    <section className="collabsSection">
      <h2>More than 25,000 teams use Collabs</h2>

      <div className="collabsGrid">
        {logos.map((logo, index) => (
          <img key={index} src={logo} alt="collab logo" />
        ))}
      </div>
    </section>
  );
};

export default Collabs;
